import { useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";
import { MemoryItem } from "../types";

export function useMemoryCreate() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    (text: string) => {
      return client.fetch<MemoryItem>("/api/memory", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ text }),
      });
    },

    {
      async onSettled() {
        await queryClient.invalidateQueries({
          queryKey: ["memory"],
        });
      },
    }
  );
}
